"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = _interopRequireDefault(require("pricing-pages-unified-ui/events.yaml"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _Raven = _interopRequireDefault(require("Raven"));

var _default = {
  events: _events.default,
  properties: {
    namespace: _Tracking.APP
  },
  lastKnownEventProperties: ['screen', 'subscreen'],
  onError: function onError(err) {
    _Raven.default.captureMessage('usage-tracker-js event error', {
      extra: {
        message: err.message
      }
    });
  }
};
exports.default = _default;
module.exports = exports.default;